import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Button, Input, Row } from "antd";
import moment from "moment";

import inquiryApi from "../../../apis/Inquiry.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

const NutrientsGPTComponent = () => {
  const dispatch = useDispatch();

  const setIsLoading = (value) => dispatch(setLoading(value));
  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);

  const [chatList, setChatList] = useState([]);
  const [question, setQuestion] = useState("");
  const bottomRef = useRef(null);

  useEffect(() => {
    getGPTChatListByUserId();
  }, []);

  useEffect(() => {
    if (bottomRef.current) {
      console.log("change chatList &&", bottomRef.current.scrollHeight);
      bottomRef.current.scrollTop = bottomRef.current.scrollHeight;
    }
  }, [chatList]);

  const getGPTChatListByUserId = async () => {
    const param = {
      user_id: user.id,
    };
    const res = await inquiryApi.getGPTChatListByUserId(param);
    setChatList(res.result);
  };

  const handleSubmit = async () => {
    try {
      setIsLoading(true);
      const param = {
        question: question,
        user_id: user.id,
      };
      addQuestion();
      const res = await inquiryApi.chatGPT(param);
      if (res.code === 200) {
        setIsLoading(false);
        getGPTChatListByUserId();
      } else {
        throw res.msg;
      }
    } catch (e) {
      setIsLoading(false);
      console.log("NutrientsGPT Chat handleSubmit error ", e);
    }
  };

  const addQuestion = () => {
    let currList = [...chatList];
    const item = {
      question: question,
      user_id: user.id,
      created_at: new Date(),
      created_by: user.id,
    };
    currList.push(item);
    setQuestion("");
    setChatList(currList);
  };

  return (
    <>
      <ContentHeaderComponent title="GPT" />
      <div className="product-register-wrap">
        <div
          className="product-register-border-box"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "stretch",
            marginTop: 25,
            paddingTop: 25,
            paddingBottom: 25,
            height: "65vh",
          }}
        >
          <div
            ref={bottomRef}
            style={{ height: "calc(100% - 32px - 20px)", overflowY: "scroll" }}
          >
            {chatList.map((chat, idx) => (
              <div key={`gpt_chat_list_${idx}`}>
                <div
                  style={{
                    textAlign: "right",
                    marginTop: 25,
                    marginBottom: 25,
                  }}
                >
                  {chat.question}
                  <p style={{ color: "#adb5bd" }}>
                    {moment(chat.created_at).format("YY-MM-DD HH:mm:ss")}
                  </p>
                </div>
                {chat.answer && (
                  <div style={{ marginTop: 25, marginBottom: 25 }}>
                    {chat.answer}
                    <p style={{ color: "#adb5bd" }}>
                      {moment(chat.updated_at).format("YY-MM-DD HH:mm:ss")}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
          {/*<div>{chatList.map((chat, idx) => <div key={`gpt_chat_list_${idx}`}>*/}
          {/*    <div style={{ textAlign: "right" }}>{chat.question}</div>*/}
          {/*    {chat.answer && <div>*/}
          {/*        {chat.answer}*/}
          {/*    </div>}*/}
          {/*</div>)}</div>*/}
          <Row wrap={false}>
            <Input
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              onPressEnter={handleSubmit}
            />
            <Button
              type="primary"
              onClick={handleSubmit}
              disabled={!question.trim()}
            >
              전송
            </Button>
          </Row>
        </div>
      </div>
    </>
  );
};

export default NutrientsGPTComponent;
